import React, { useEffect, useState } from "react";
import PersonnelHomeHeader from "./Components/PersonnelHomeHeader";
import ContentCard from "./Components/ContentCard";
import { Col, Form, Row, Spin } from "antd";
import PersonnelHomePageSummaryCard from "./Components/PersonnelHomePageSummaryCard";
import { OnboardModal } from "./Components/OnboardModal";
import usePersonnelInfoService from "../../../services/usePersonnelInfoService";
import useCommonsService from "../../../services/useCommonsService";
import dayjs from "dayjs";
import PageRoutes from "../../../utils/routes";

const PersonnelHome = () => {
  const { useGetPersonnelInfo, useSetPersonnelOnboarding } =
    usePersonnelInfoService();
  const { data: personnelInfoData, isLoading: isPersonnelDataLoading } =
    useGetPersonnelInfo();
  const { mutateAsync: setPersonnelOnboarding, isPending: isOnboardLoading } =
    useSetPersonnelOnboarding();
  const { useGenders, useGetAllSectors, useGetLabelKeys } = useCommonsService();
  const { data: genders } = useGenders();
  const { data: sectors } = useGetAllSectors();
  console.log("personel data is", personnelInfoData);
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(
    personnelInfoData?.data?.phoneNumber === null
  );
  console.log("personel info data", personnelInfoData);

  useEffect(() => {
    console.log("personel info data is ", personnelInfoData);
    if (isModalVisible && personnelInfoData !== undefined) {
      form.setFieldsValue({
        name: personnelInfoData.data.name,
        surname: personnelInfoData.data.surname,
        email: personnelInfoData.data.email,
      });
    }
  }, [personnelInfoData]);

  const handleModalSubmit = async (values) => {
    const requestBody = {
      countryCode: 90,
      phonenNumber: values.phoneNumber.toString(),
      name: values.name,
      surname: values.surname,
      email: values.email,
      summary: values.summary,
      birthPlace: values.birthPlace,
      gender: values.gender,
      sectorIds: values.sectorIds,
      birthDate: dayjs(values.birthDate).format("YYYY-MM-DD"),
    };
    console.log("Form values:", requestBody);
    try {
      await setPersonnelOnboarding(requestBody);
    } catch (error) {}

    setIsModalVisible(false);
  };
  return (
    <div>
      <Spin spinning={isPersonnelDataLoading}>
        <PersonnelHomeHeader
          email={personnelInfoData?.data.email}
          imageUrl={personnelInfoData?.data.imageUrl}
          name={personnelInfoData?.data.name}
          surname={personnelInfoData?.data.surname}
        />
        <Row>
          <Col md={8} xs={24}>
            <PersonnelHomePageSummaryCard />
          </Col>
          <Col md={16} xs={24}>
            <ContentCard
              title="Özgeçmişim"
              explanation="İlanlara başvururken şansını arttırmak için özgeçmişini doldur."
              route={PageRoutes.detailedProfile}
            />
            <ContentCard
              title="Başvurduğum İlanlar"
              explanation="Başvurduğun ilanlara göz atabilirsin"
              route={PageRoutes.appliedAdverts}
            />
            <ContentCard
              title="Favori İlanlarım"
              explanation="Favorilere eklediğin ilanlara göz atabilir, dilediğin ilanlara başvurabilirsin"
              route={PageRoutes.favoriteAdverts}
            />
            <ContentCard
              title="Sana Uygun İlanlar"
              explanation="Senin için seçtiğimiz ilanlara göz atabilirsin"
              route={PageRoutes.recommendedAdverts}
            />
            <ContentCard
              title="Döküman Yükle"
              explanation="Başvurunun Onaylandığı İşler İçin Belgelerini Düzenle"
              route={PageRoutes.documentManagement}
            />
          </Col>
        </Row>
        <OnboardModal
          genders={genders}
          visible={isModalVisible}
          onFinish={handleModalSubmit}
          form={form}
          sectors={sectors}
          isLoading={isOnboardLoading}
        />
      </Spin>
    </div>
  );
};

export default PersonnelHome;
